module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Pièces jointes","photos":"Photos","schema":"Schémas","technicalFiles":"Documents techniques","report":"Comptes rendus","conventions":"Conventions","other":"Autres","download":"Télécharger","fileName":"Nom du fichier","fileSize":"Taille"}}')
  delete Component.options._Ctor
}
